import { render, staticRenderFns } from "./ToolsTable.vue?vue&type=template&id=496c3b6e&scoped=true&"
import script from "./ToolsTable.vue?vue&type=script&lang=js&"
export * from "./ToolsTable.vue?vue&type=script&lang=js&"
import style0 from "./ToolsTable.vue?vue&type=style&index=0&id=496c3b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c3b6e",
  null
  
)

export default component.exports